export const Onboard = {
	expiredContent: {
		title: "⚠️ Your Onboarding Link Has Expired",
		description: `
Oops! This link is no longer active. Onboarding links expire after a certain period or can only be used once.
If you haven’t set up your account yet, ask your admin to resend an invitation.
`,
		footer_content: "If you’ve already completed onboarding, you can",
	},
	unknow_error: {
		title: "Unexpected Error Occurred",
		description:
			"An unexpected error has occurred. Please try again later or contact support if the issue persists.",
	},
	form: {
		title: "Welcome",
		description:
			"You’ve been invited to join {{organizationName}} on Lens. Let’s get you set up and ready to start!",
		button_text: "Join {{organizationName}}",
		button_text_loading: "Onboarding...",
	},
	login_link_text: "Login",
};
